
import { ref, inject, shallowRef, reactive, defineProps } from "vue";
//   import Header from "@/components/header/header.vue";
export default {
  props: ['currentStep'],
  setup(props: object, ctx: any) {
    const handleCloseAccountClick = () => {
      ctx.emit('currentPage', 2)
    }

    return {
      handleCloseAccountClick
    }
  },
};
